import React from "react";
import { ShareWhatsapp } from "../../../src/assets/img/svg/icons";

const WhatsappButton: React.FC = () => {
  return (
    <a
      href="https://wa.me/+5511971823024"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-50 flex items-center justify-center w-16 h-16 transition-all bg-green-500 rounded-full shadow-lg bg-opacity-20 bottom-4 lg:bottom-8 right-2 lg:right-8 hover:bg-green-600 hover:scale-110"
    >
        <ShareWhatsapp className="relative z-10 w-12 h-12 text-white" />

    </a>
  );
};

export default WhatsappButton;
